export default __webpack_public_path__ + "static/media/001-air-pump.7b090a18.png";